import customer from './customer';
import settings from './settings';
import viewSettings from './viewSettings';
import appSetting from './appSettings';
import appPermissions from './appPermissions';
import posFeatures from './posFeatures';
const rootReducer = (state = {}, action) => {
    return {
        viewSettings: viewSettings(state.viewSettings, action, state),
        customer: customer(state.customer, action, state),
        settings: settings(state.settings, action, state),
        appSetting: appSetting(state.appSetting, action, state),
        posFeatures: posFeatures(state.posFeatures, action, state),
        appPermissions: appPermissions(state.appPermissions, action, state),
    };
};


export default rootReducer;